import { Result } from "antd";
import { Layout, Header, Content } from "./Layout";

const Unauthenticated = () => {
	const subTitle = "You don't have permission to access this form";
	return (
		<Layout>
			<Header showCmeFormHeader={false} />
			<Content>
				<Result title="Can't Access Online Forms" subTitle={subTitle}>
					<div className="desc">
						<p>
							If you need access to this online form application,
							please contact your support / administrator
						</p>
						<p>
							If you have more than one work account, you may be
							signed in with the wrong one. Hover over the icon in
							the top right to see which email address you are
							signed in with, then use <strong>Sign out</strong> to
							switch accounts.
						</p>
					</div>
				</Result>
			</Content>
		</Layout>
	);
};

export default Unauthenticated;
